import * as React from 'react';

import { ContentCard } from '@rematter/ui-web';

import { PrinterFormState } from '../../../_state/printerForm.state';
import { PrinterDetailRecord } from '../../../types/sidecar';

import { PrinterFormFields } from './PrinterFormFields';
import { PrinterFormFooterActions } from './PrinterFormFooterActions';

type Props = {
  printer?: PrinterDetailRecord | null;
  printerId?: string;
  onDiscard?: () => void;
  onSaveUpdates?: (data?: PrinterFormState) => void;
  isSaving?: boolean;
};

export const PrinterTabInfo: React.FC<Props> = ({
  printer,
  printerId,
  onDiscard,
  onSaveUpdates,
  isSaving = false,
}) => (
  <div className="@PrinterTabInfo flex max-h-full flex-col gap-5 p-5">
    <ContentCard className="p-0 pt-5">
      <PrinterFormFields printer={printer} printerId={printerId} />
      <PrinterFormFooterActions
        onSaveUpdates={onSaveUpdates}
        onDiscard={onDiscard}
        isSaving={isSaving}
      />
    </ContentCard>
  </div>
);
